<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div class="max-w-1xl mx-auto bg-white p-8 rounded-lg shadow-lg">
  <div class="flex flex-row justify-between items-center mb-3">
    <div class="flex flex-row md:gap-3 items-center">
      <div class="flex flex-row flex-nowrap md:gap-3 items-center">
        <h1 class="headeradminui-text md:break-keep">
          Manage Forum Registrations
        </h1>
      </div>
      <div>
        <img
          class="separator"
          src="../../../../assets/icons/separator.svg"
          alt="i"
        />
      </div>
      <div>
        <h1 class="sub-headeradminui-text">
          {{ totalRecords }} Forum Registrations
        </h1>
      </div>
    </div>
  </div>

  <div
    class="flex items-start gap-4 flex-row"
    style="background: #ececec; padding: 30px"
  >
    <!-- Forum Info Card -->
    <nz-card
      [nzLoading]="forumLoading"
      *ngIf="forum"
      style="width: 400px"
      [nzBordered]="false"
      nzTitle="Forum Info"
    >
      <p>Forum Name: {{ forum.name }}</p>
      <p>Category: {{ forum.categoryName }}</p>
      <p *ngIf="forum.entryFee && forum.entryFee[0]">
        Amount: {{ forum.entryFee[0].amount }}
      </p>
      <div nz-row>
        <p>Payment Type:</p>
        <nz-tag [nzColor]="'red'">
          {{ utils.convertToTitleCase(forum.paymentType) }}
        </nz-tag>
      </div>
    </nz-card>

    <!-- Upload Registration CSV Card -->
    <nz-card
      style="width: 400px"
      [nzBordered]="false"
      nzTitle="Upload Registration CSV"
      [nzLoading]="csvLoading"
    >
      <button
        nz-button
        nzType="dashed"
        (click)="downloadSampleTemplate()"
      >
        <span nz-icon nzType="download"></span>
        Show Sample Template
      </button>

      <p class="mt-2" style="font-size: 12px; color: #888">
        Note: The sample marks each column as (Required) or (Optional).
        Remove these labels from the header row before uploading the CSV.
      </p>

      <input
        type="file"
        accept=".csv"
        (change)="onCsvFileChange($event)"
        nz-button
        class="mt-4"
        [disabled]="csvLoading"
      />

      <button
        nz-button
        [disabled]="!selectedCsvFile || csvLoading"
        class="mt-4"
        (click)="uploadCsv()"
      >
        <ng-container *ngIf="!csvLoading; else loadingTpl">
          Upload CSV
        </ng-container>
        <ng-template #loadingTpl>
          <i nz-icon nzType="loading"></i> Uploading...
        </ng-template>
      </button>

      <button
        nz-button
        [disabled]="!selectedCsvFile || csvLoading"
        class="mt-4"
        (click)="viewCsvData()"
      >
        <ng-container *ngIf="!csvLoading; else loadingTpl"> View </ng-container>
        <ng-template #loadingTpl>
          <i nz-icon nzType="loading"></i> Uploading...
        </ng-template>
      </button>
    </nz-card>
  </div>

  <nz-spin
    [nzSpinning]="forumRegistrationsLoading"
    nzTip="Fetching Forum registrations...."
  >
    <div nz-row nzJustify="end" nzAlign="middle" class="mb-3">
      <div nz-col class="p-1">
        <nz-input-group nzSearch nzSize="large" [nzAddOnAfter]="suffixButton">
          <input
            type="text"
            nz-input
            [(ngModel)]="globalSearchInput"
            placeholder="Search for user name"
          />
        </nz-input-group>
      </div>
    </div>

    <nz-table
      #basicTable
      [nzData]="data"
      [nzTitle]="tableHead"
      [nzScroll]="{ y: '500px' }"
      class="mt-5"
      [nzShowPagination]="true"
      [nzFrontPagination]="false"
      [nzTotal]="totalRecords"
      [nzPageSize]="pageSize"
      [nzBordered]="true"
      [nzShowSizeChanger]="true"
      [nzPageSizeOptions]="pageSizeOptions"
      [nzPageIndex]="page"
      nzTableLayout="fixed"
      (nzPageIndexChange)="onPageIndexChange($event)"
      (nzPageSizeChange)="onPageSizeChange($event)"
    >
      <thead>
        <tr>
          <th>User Name</th>
          <th>
            User Email
            <nz-filter-trigger
              [nzActive]="!!emailColumnSearch"
              [nzDropdownMenu]="userEmailSearch"
            >
              <span nz-icon nzType="search"></span>
            </nz-filter-trigger>
          </th>
          <th nzWidth="30%">Tags</th>
          <th
            (nzSortOrderChange)="sortRegisteredDates($event)"
            nzCustomFilter
            nzShowSort="true"
          >
            Registered On
            <nz-filter-trigger
              [nzActive]="!!currentDateFilters"
              [nzDropdownMenu]="dateFilterMenu"
            >
              <span nz-icon nzTheme="outline" nzType="schedule"></span>
            </nz-filter-trigger>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of basicTable.data">
          <td>{{ data.userName }}</td>
          <td>{{ data.userEmail }}</td>
          <td>
            <div *ngIf="data.tags && data.tags.length > 0">
              <nz-tag
                *ngFor="let tag of data.tags"
                [nzColor]="data.paymentTypeColor"
              >
                {{ utils.convertToTitleCase(tag) }}
              </nz-tag>
            </div>
            <div *ngIf="!data.tags || data.tags.length === 0">N/A</div>
          </td>
          <td>{{ utils.convertEpochToFormattedDate(data.registerOn) }}</td>
        </tr>
      </tbody>
      <ng-template #tableHead>
        <div nz-row nzJustify="space-between">
          <div nz-col>
            <span class="font-bold">Forum Registrations</span>
          </div>
          <div nz-col>
            <div nz-row nzAlign="middle">
              <div nz-col class="pr-4">
                <nz-switch
                  (ngModelChange)="testForumChangeFn($event)"
                  [(ngModel)]="showTestForums"
                  nzCheckedChildren="Hide Test Forum Registrations"
                  nzUnCheckedChildren="Show Test Forum Registrations"
                ></nz-switch>
              </div>
              <div nz-col class="pr-4">
                <button
                  nz-button
                  nzSize="small"
                  nzType="primary"
                  (click)="exportRegistrationTable()"
                >
                  Export
                </button>
              </div>
              <div nz-col>
                <button
                  nz-button
                  nzSize="small"
                  nzType="primary"
                  (click)="resetFilter()"
                >
                  Clear Filters
                </button>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </nz-table>
  </nz-spin>
</div>

<!-- Search Button Template -->
<ng-template #suffixButton>
  <button
    nz-button
    nzType="primary"
    nzSize="small"
    nzSearch
    (click)="searchGlobal()"
  >
    Search
  </button>
</ng-template>

<!-- User Email Search Dropdown -->
<nz-dropdown-menu #userEmailSearch="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div class="m-1" nz-row>
      <div nz-col>
        <input
          [(ngModel)]="emailColumnSearch"
          nz-input
          placeholder="Search by email"
          nzSize="small"
        />
      </div>
    </div>
    <div class="m-1" nz-row nzJustify="end">
      <div nz-col>
        <button
          class="m-1"
          nz-button
          nzSize="small"
          nzType="primary"
          (click)="userEmailSearchFn()"
        >
          Search
        </button>
        <button
          class="m-1"
          nz-button
          nzSize="small"
          (click)="resetUserEmailSearch()"
        >
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>
<nz-dropdown-menu #dateFilterMenu="nzDropdownMenu">
  <div class="bg-white drop-shadow-md m-1 p-2 rounded-md">
    <div class="ng-row">
      <nz-range-picker
        [nzFormat]="dateFormat"
        [(ngModel)]="forumsRegistrationColumnFilterDate"
      ></nz-range-picker>
    </div>
    <div nz-row class="mt-5 gap-4" nzJustify="end">
      <div nz-col>
        <button class="m-1" nz-button nzType="primary" (click)="dateFilter()">
          Apply
        </button>
      </div>
      <div nz-col>
        <button
          class="m-1"
          nz-button
          nzType="primary"
          (click)="resetDateFilter()"
        >
          Reset
        </button>
      </div>
    </div>
  </div>
</nz-dropdown-menu>

<nz-modal
  [(nzVisible)]="isCsvModalVisible"
  nzTitle="CSV Preview"
  [nzWidth]="1400"
  (nzOnCancel)="isCsvModalVisible = false"
  [nzFooter]="null"
>
  <ng-container *nzModalContent>
    <ng-container *ngIf="selectedCsvData.length > 0; else noDataTpl">
      <nz-table
        #csvTable
        [nzData]="selectedCsvData"
        [nzBordered]="true"
        [nzScroll]="{ x: '1000px', y: '400px' }"
        nzSize="middle"
      >
        <thead>
          <tr>
            <th *ngFor="let key of csvHeaders">{{ key }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of csvTable.data">
            <td *ngFor="let key of csvHeaders">{{ row[key] }}</td>
          </tr>
        </tbody>
      </nz-table>
    </ng-container>

    <ng-template #noDataTpl>
      <p>No CSV data to display</p>
    </ng-template>
  </ng-container>
</nz-modal>

<nz-modal
  [(nzVisible)]="isCsvValidationModalVisible"
  nzTitle="CSV Validation Errors"
  [nzWidth]="800"
  (nzOnCancel)="isCsvValidationModalVisible = false"
  [nzFooter]="null"
>
  <ng-container *nzModalContent>
    <p>
      The following rows are missing required fields. Please fix the CSV and
      upload again.
    </p>
    <nz-table
      #invalidCsvTable
      [nzData]="invalidCsvRows"
      [nzBordered]="true"
      [nzScroll]="{ y: '400px' }"
      nzSize="middle"
      [nzShowPagination]="invalidCsvRows.length > 10"
    >
      <thead>
        <tr>
          <th>Row</th>
          <th>Email</th>
          <th>Reason</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let invalidRow of invalidCsvTable.data">
          <td>{{ invalidRow.row }}</td>
          <td>{{ invalidRow.email }}</td>
          <td>{{ invalidRow.reason }}</td>
        </tr>
      </tbody>
    </nz-table>
  </ng-container>
</nz-modal>

<nz-modal
  [(nzVisible)]="isRegistrationResultModalVisible"
  nzTitle="Registration Upload Result"
  [nzWidth]="1000"
  (nzOnCancel)="isRegistrationResultModalVisible = false"
  [nzFooter]="null"
>
  <ng-container *nzModalContent>
    <ng-container *ngIf="registrationResult">
      <div nz-row nzGutter="16" class="mb-4">
        <div nz-col>
          <nz-tag [nzColor]="'blue'"
            >Total : {{ registrationResult.total }}</nz-tag
          >
        </div>
        <div nz-col>
          <nz-tag [nzColor]="'green'"
            >Success : {{ registrationSuccessCount() }}</nz-tag
          >
        </div>
        <div nz-col>
          <nz-tag [nzColor]="'red'"
            >Failed : {{ registrationResult.failed.length }}</nz-tag
          >
        </div>
        <div nz-col>
          <nz-tag [nzColor]="'orange'"
            >Skipped : {{ registrationResult.skipped.length }}</nz-tag
          >
        </div>
      </div>

      <nz-tabset>
        <nz-tab
          *ngIf="registrationResult.failed.length"
          [nzTitle]="'Failed (' + registrationResult.failed.length + ')'"
        >
          <div nz-row nzJustify="end" class="mb-2">
            <div nz-col>
              <button
                nz-button
                nzSize="small"
                nzType="primary"
                [disabled]="!registrationResult.failed.length"
                (click)="
                  exportRegistrationRows(registrationResult.failed, 'failed')
                "
              >
                Export
              </button>
            </div>
          </div>

          <nz-table
            #failedTable
            [nzData]="registrationResult.failed"
            [nzBordered]="true"
            [nzScroll]="{ y: '400px' }"
            nzSize="middle"
            [nzShowPagination]="registrationResult.failed.length > 10"
          >
            <thead>
              <tr>
                <th>Email</th>
                <th>Reason</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of failedTable.data">
                <td>{{ row.email }}</td>
                <td>{{ row.reason }}</td>
              </tr>
            </tbody>
          </nz-table>
        </nz-tab>

        <nz-tab
          *ngIf="registrationResult.skipped.length"
          [nzTitle]="'Skipped (' + registrationResult.skipped.length + ')'"
        >
          <div nz-row nzJustify="end" class="mb-2">
            <div nz-col>
              <button
                nz-button
                nzSize="small"
                nzType="primary"
                [disabled]="!registrationResult.skipped.length"
                (click)="
                  exportRegistrationRows(registrationResult.skipped, 'skipped')
                "
              >
                Export
              </button>
            </div>
          </div>

          <nz-table
            #skippedTable
            [nzData]="registrationResult.skipped"
            [nzBordered]="true"
            [nzScroll]="{ y: '400px' }"
            nzSize="middle"
            [nzShowPagination]="registrationResult.skipped.length > 10"
          >
            <thead>
              <tr>
                <th>Email</th>
                <th>Reason</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of skippedTable.data">
                <td>{{ row.email }}</td>
                <td>{{ row.reason }}</td>
              </tr>
            </tbody>
          </nz-table>
        </nz-tab>
      </nz-tabset>
    </ng-container>
  </ng-container>
</nz-modal>
